// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"267":"35797891","371":"9a594dab","453":"6ef695a1"}[chunkId] + ".chunk.js";
};